import React from "react";

import { ScriptLoader } from "../RenderScripts/RenderScripts";

const REACH_FORM_SCRIPTS = [
  "https://forms.ccbp.in/webflow/runtime.b94596fe7c03cf2e.js",
  "https://forms.ccbp.in/webflow/polyfills.eefc68570d0fb837.js",
  "https://forms.ccbp.in/webflow/intensiveQualified.fcd591a85db52dd2.js",
];

export default function IntensiveReachFormScripts() {
  return REACH_FORM_SCRIPTS.map((src) => (
    <ScriptLoader key={src} src={src} strategy="afterInteractive" type="module" />
  ));
}
